import React from "react";
import './Table_Comp.css'
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { format, parseISO } from "date-fns";

function Table_Comp({ RowClick, GridData, RowClickMob }) {
    const DateFormate = (data) => {
        return <td>{format(parseISO(data.dataItem.issueDate), "dd/MM/yyyy")}</td>
    }

    return (
        <div className="Table_Comp_Main_Class">
            <div className="permitAccess_webTable">
                <Grid onRowClick={RowClick} className="TableClassMain"
                    data={GridData?.data} >
                    <GridColumn field="jobDescription" title="Description" width="180px" />
                    <GridColumn field="permitNumber" title="Permit ID" width="180px" />
                    <GridColumn field="permitType" title="Permit Type" width="180px" />
                    <GridColumn field="plant" title="Plant Name" width="180px" />
                    <GridColumn field="permitStatus" title="Permit Status" width="150px" />
                    <GridColumn field="departmentName" title="Department" width="150px" />
                    <GridColumn field="currentApprovalLevel" title="Approval Pending" width="150px" />
                    <GridColumn field="name" title="Name" width="150px" />
                    <GridColumn field="issueDate" cell={DateFormate} title="Issue Date" width="100px" />
                </Grid><br />
            </div>

            <div>
                <div className="PermitAccess_MobTable">
                    {GridData?.data?.map((List_item, index) => (
                        <div className="List_Card" onClick={() => RowClickMob(List_item)} key={index}>
                            {List_item.permitNumber !== null ?
                                <div className="row" style={{ margin: "-2% 0% -4% -2%", paddingTop: "1%" }}>
                                    <div className="col-12" style={{ fontWeight: "bold", color: "#354e6c" }} >
                                        <p >{List_item.permitNumber} - {List_item.plant}</p>
                                    </div>
                                </div> :
                                <div className="row" style={{ margin: "-2% 0% -4% -2%", paddingTop: "1%" }}>
                                    <div className="col-12" style={{ fontWeight: "bold", color: "#354e6c" }} >
                                        <p >{List_item.plant}</p>
                                    </div>
                                </div>
                            }
                            <div className="row" style={{ margin: "0% -2% -4% -2%" }}>
                                <div className="col-6" style={{ fontWeight: "500" }}>
                                    <p className="gridLeft"><b>Status :</b>{List_item.permitStatus}</p>
                                </div>
                                <div className="col-6" style={{ fontWeight: "bold" }}>
                                    <p className="gridRight">{format(parseISO(List_item.issueDate), "dd/MM/yyyy")}</p>
                                </div>
                            </div>
                            <div className="row" style={{ margin: "0% -2% -3% -2%" }}>
                                <div className="col-6" style={{ fontWeight: "500" }}>
                                    <p className="gridLeft"><>Approval L1 :</>{List_item.l1Status}</p>
                                </div>
                                <div className="col-6" style={{ fontWeight: "bold" }}>
                                    <p className="gridRight"><>Approval L2 :</>{List_item.l2Status}</p>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-12" style={{ margin: "-1% 0% -4% 1%", fontWeight: "bold" }}>
                                    <p className="gridLeft"><>Name :</>{List_item.name}</p>
                                </div>
                                <div className="col-12" style={{ display: "flex", alignItems: "center", justifyContent: "start", margin: "0% 0% -2% 1%" }}>
                                    <p><b>Des :</b>{List_item.jobDescription}</p>
                                </div>
                            </div>
                        </div>
                    )
                    )}
                </div>
            </div>
        </div>
    )
};

export default Table_Comp;